// Mock data for Sai Ananta landing page

export const projectInfo = {
  name: "Sai Ananta",
  tagline: "Blessed Forever",
  location: "Wadhmukhwadi, Pune",
  startingPrice: "₹66 Lacs*",
  configuration: "2 & 3 BHK Apartments",
  reraNumber: "PR1260002502966",
  
  hero: {
    title: "Sai Ananta",
    subtitle: "The Benchmark of Blessed Living",
    description: "Experience serenity and prosperity in 2 & 3 BHK homes starting from ₹66 Lacs*",
    location: "Wadhmukhwadi, Pune",
    elevationImage: "https://customer-assets.emergentagent.com/job_c3d6dd33-c332-4562-92cf-4b2464c4812d/artifacts/37xhztcx_Sai%20Ananta%20Elevation.jpeg"
  },

  overview: {
    title: "The Tallest Tower of Wadmukhwadi",
    subtitle: "Where Blessings Meet Modern Living",
    description: "Nestled in the spiritually enriched neighborhood of Wadhmukhwadi, Sai Ananta offers a perfect blend of peace, prosperity, and modern convenience. Located near Sai Mandir with green, unobstructed views, this landmark stands blessed forever."
  },

  highlights: [
    {
      icon: "MapPin",
      title: "Prime Spiritual Location",
      description: "Beside Shri Sant Dnyaneshwar Maharaj Temple & Sai Mandir"
    },
    {
      icon: "TrendingUp",
      title: "High Growth Potential",
      description: "15-30% property appreciation expected in 3-5 years"
    },
    {
      icon: "Building2",
      title: "Premium Residences",
      description: "Spacious 2 & 3 BHK homes with modern amenities"
    },
    {
      icon: "Route",
      title: "Excellent Connectivity",
      description: "200m from Alandi-Pune Highway, 1.5km from Inner Ring Road"
    },
    {
      icon: "Sparkles",
      title: "Rooftop Amenities",
      description: "Sunset deck, meditation area, yoga deck & more"
    },
    {
      icon: "Award",
      title: "Trusted Developer",
      description: "Shree Venkateshwara Group - 20+ years, 100+ projects"
    }
  ],

  pricing: [
    {
      type: "2 BHK",
      price: "₹66 Lacs",
      carpetArea: "849 Sq Ft",
      features: ["Spacious Bedrooms", "Modern Kitchen", "Premium Fittings", "Ample Natural Light"]
    },
    {
      type: "3 BHK",
      price: "₹92 Lacs",
      carpetArea: "1137 Sq Ft",
      features: ["Luxurious Interiors", "Master Bedroom", "Spacious Living", "Premium Finishes"],
      featured: true
    }
  ],

  amenities: {
    rooftop: [
      { name: "Sunset Deck", icon: "Sunset" },
      { name: "Meditation Deck", icon: "Flower2" },
      { name: "Gazebo", icon: "Home" },
      { name: "Yoga Deck", icon: "Activity" },
      { name: "Senior Citizen Plaza", icon: "Users" },
      { name: "Multi-activity Huts", icon: "Grid3x3" },
      { name: "Open Gym", icon: "Dumbbell" },
      { name: "Party Lawn", icon: "PartyPopper" },
      { name: "Kids Play Area", icon: "Baby" }
    ],
    ground: [
      { name: "Swimming Pool", icon: "Waves" },
      { name: "Kids Swimming Pool", icon: "Droplet" },
      { name: "Pool-side Deck", icon: "Armchair" },
      { name: "Multi-functional Hall", icon: "Building" },
      { name: "Party Lawn with Stage", icon: "Music" },
      { name: "Garden & Sitout", icon: "Trees" },
      { name: "Children's Play Area", icon: "Gamepad2" }
    ],
    other: [
      { name: "Clubhouse", icon: "Home" },
      { name: "EV charging for selected units only", icon: "Zap" },
      { name: "Digital Lock & VDP", icon: "Lock" },
      { name: "DG backup for common areas only", icon: "Battery" }
    ]
  },

  gallery: [
    {
      url: "https://customer-assets.emergentagent.com/job_vivanta-2-3-bhk/artifacts/o83pgwpu_Real%20Estate%20Project%20Wadmukhwadi.jpg",
      title: "Project View"
    },
    {
      url: "https://customer-assets.emergentagent.com/job_vivanta-2-3-bhk/artifacts/ngdxil8u_Rooftop%20Amenities%20Pune%20Apartment.jpg",
      title: "Rooftop Amenities"
    },
    {
      url: "https://customer-assets.emergentagent.com/job_vivanta-2-3-bhk/artifacts/h28mvbhu_Clubhouse%20Amenities%20Residential%20Project.jpg",
      title: "Clubhouse"
    },
    {
      url: "https://customer-assets.emergentagent.com/job_vivanta-2-3-bhk/artifacts/m4s8327b_Modern%20Residential%20Tower%20Wadmukhwadi%20Pune.jpg",
      title: "Residential Tower"
    },
    {
      url: "https://customer-assets.emergentagent.com/job_vivanta-2-3-bhk/artifacts/y3b46rqk_Best%20Property%20in%20Wadmukhwadi%20Pune.jpg",
      title: "Premium Property"
    },
    {
      url: "https://customer-assets.emergentagent.com/job_c3d6dd33-c332-4562-92cf-4b2464c4812d/artifacts/37xhztcx_Sai%20Ananta%20Elevation.jpeg",
      title: "Elevation View"
    }
  ],

  nearbyLocations: [
    { name: "Nashik Highway", distance: "8 mins", icon: "Route" },
    { name: "Airport", distance: "25 mins", icon: "Plane" },
    { name: "Railway Station", distance: "35 mins", icon: "Train" },
    { name: "Chakan MIDC", distance: "20 mins", icon: "Briefcase" },
    { name: "EON IT Park", distance: "42 mins", icon: "Building2" },
    { name: "Phoenix Market City", distance: "30 mins", icon: "ShoppingBag" },
    { name: "Alandi-Pune Highway", distance: "200 m", icon: "Navigation" },
    { name: "Sai Mandir", distance: "Near", icon: "MapPin" }
  ],

  developer: {
    name: "Shree Venkateshwara Group & Shinde Group",
    logo: "https://customer-assets.emergentagent.com/job_c3d6dd33-c332-4562-92cf-4b2464c4812d/artifacts/gvegs6hp_SVG%20Developer%20Logo.pdf",
    experience: "20+ Years",
    projects: "100+ Completed Projects",
    families: "1,000+ Happy Families",
    expertise: "Diversified Expertise Across Real Estate, RMC & Contracting",
    description: "With over two decades of excellence in real estate, Shree Venkateshwara Group and Shinde Group have been creating landmark residential projects across Pune. Our commitment to quality, timely delivery, and customer satisfaction has made us one of the most trusted names in the industry."
  },

  contact: {
    phone: "+91 70663 31177",
    email: "info@saiananta.com",
    address: "Laxmi-Narayan Nagar, Wadmukhwadi, Charholi Budruk, Pimpri-Chinchwad, Maharashtra 412105"
  },

  // Map coordinates for Wadhmukhwadi, Pune
  mapCenter: {
    lat: 18.6633,
    lng: 73.9497
  }
};

// Form submission handler (mock)
export const submitEnquiry = async (formData) => {
  // Simulate API call
  return new Promise((resolve) => {
    setTimeout(() => {
      console.log("Enquiry submitted:", formData);
      resolve({ success: true, message: "Thank you! We'll contact you soon." });
    }, 1000);
  });
};

// Site visit booking handler (mock)
export const bookSiteVisit = async (bookingData) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      console.log("Site visit booked:", bookingData);
      resolve({ success: true, message: "Your site visit has been scheduled!" });
    }, 1000);
  });
};
